import { atom, useRecoilState } from 'recoil';

export const catalogLandingProductsType = atom<'all' | 'available' | 'not-available'>({
    key: 'catalogLandingProductsType',
    default: 'all',
});

export const useCatalogLandingProductsType = () => useRecoilState(catalogLandingProductsType);
